import styles from './MigrationToSNInfoModal.module.scss';
import { Modal } from 'src/components/Modal';
import { PROJECT_NAME, SUPER_PROJECT_NAME, SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { Icon } from 'src/components/Icon';
import { ArrowFatLineRight } from '@phosphor-icons/react';
import { env } from 'src/env';
import {
  useMigrationToSNModalActions,
  useMigrationToSNModalState,
} from 'src/hooks';

export const MigrationToSNInfoModal = () => {
  const { shouldShowMigrationToSNModal } = useMigrationToSNModalState();
  const { changeShouldShowMigrationToSNModal } = useMigrationToSNModalActions();

  const handleCloseClick = () => {
    changeShouldShowMigrationToSNModal(false);
  };

  const handleGoToSNClick = () => {
    window.location.href = env.REACT_APP_SUPER_NINJA_URL;
  };

  return (
    <Modal
      open={shouldShowMigrationToSNModal}
      onClose={handleCloseClick}
      className={styles.root}
      overlayClassName={styles.overlay}
      showCloseIcon
      blockScroll={false}
    >
      <div className={styles.contentWrapper}>
        <div className={styles.headerIcons}>
          <Icon size={64} type="ninjaMainIcon" />
          <ArrowFatLineRight size={SVG_SIZE_M} weight="fill" />
          <Icon size={64} type="superNinjaMainIcon" />
        </div>
        <div className={styles.headerTitle}>
          <h4 className={styles.title}>Important platform upgrade</h4>
          <p className={styles.description}>
            We are migrating from {PROJECT_NAME} to {SUPER_PROJECT_NAME}, our
            enhanced platform with powerful new features and expanded
            capabilities.
          </p>
        </div>
        <span className={styles.hintText}>
          Your historical threads remain viewable, but new work should be done
          in SuperNinja
        </span>
        <div className={styles.footer}>
          <Button color="highlight" onClick={handleGoToSNClick}>
            Get started with {SUPER_PROJECT_NAME}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
